import angular from 'angular'

const listPage = require('./view/list.html')
const listCtrl = require('./list')
import accountModalCtrl from './accountModalCtrl'

function configRouter($stateProvider) {
    $stateProvider.state('input.inputInvoice.InvAccountManagement', {
        url: '/InvAccountManagement',
        abstract: true,
        template: '<div ui-view></div>',
        default: 'input.inputInvoice.InvAccountManagement.list',
        title: '发票入账管理',
    })
    $stateProvider.state('input.inputInvoice.InvAccountManagement.list', {
        url: '/list',
        template: listPage,
        controller: 'InvAccountManagementListCtrl',
    })
}

export default angular
    .module('input.inputInvoice.InvAccountManagement', [])
    .config(['$stateProvider', configRouter])
    .controller('accountModalCtrl', accountModalCtrl)
    .controller('InvAccountManagementListCtrl', listCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/InvAccountManagement/index.js